'use client';
import Link from 'next/link';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';

const FAQS = [
  { q: 'Do I need technical skills to become an agent?', a: 'No. You only need to find clients and place orders. Our expert team handles all technical work — website building, press releases, and compliance filings.' },
  { q: 'What is the ₹4,999 registration fee for?', a: 'It is a one-time lifetime access fee. You get your agent dashboard, authorization certificate, free training videos, and access to all services — forever.' },
  { q: 'How fast are orders delivered?', a: 'Most orders are delivered within 24 hours. Complex projects may take up to 48–72 hours. You will be notified at every step.' },
  { q: 'How does the Refer & Earn program work?', a: 'Share your unique referral link. When someone registers using your link and places an order, you earn 15% commission on that order — credited directly to your wallet.' },
  { q: 'How do I withdraw my earnings?', a: 'You can withdraw your wallet balance directly to your bank account from the Wallet section in your dashboard. Withdrawals are processed within 2–3 business days.' },
  { q: 'Can I sell all three services?', a: 'Yes! You can sell Website Development, Press Release, and Business Compliance services. There is no limit on the number of services you can offer to clients.' },
  { q: 'What happens after I place an order?', a: 'Our expert team picks up the order immediately and begins work. You will receive status updates and the final deliverable is shared with you within 24 hours.' },
  { q: 'Is there a monthly fee?', a: 'No. The ₹4,999 is a one-time lifetime registration fee. There are no monthly fees, no hidden charges, and no renewal costs.' },
];

export default function FAQsPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="min-h-screen bg-white text-[#0f172a]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#1a56ff] mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">Frequently Asked Questions</h1>
        <p className="text-slate-500 text-sm mb-10">Everything you need to know about dropservice.in and becoming an agent.</p>

        <div className="space-y-3">
          {FAQS?.map((faq, i) => (
            <div key={i} className="border border-slate-100 rounded-2xl overflow-hidden">
              <button
                className="w-full text-left px-5 py-4 flex items-center justify-between gap-3 hover:bg-slate-50 transition-colors"
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <span className="text-sm font-semibold text-[#0f172a]">{faq?.q}</span>
                <ChevronRight size={16} className={`text-slate-400 flex-shrink-0 transition-transform duration-200 ${openFaq === i ? 'rotate-90' : ''}`} />
              </button>
              {openFaq === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-slate-500 leading-relaxed">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 bg-blue-50 rounded-2xl p-6">
          <p className="text-sm text-slate-600">Still have questions? <a href="mailto:support@dropservice.in" className="text-[#1a56ff] font-medium hover:underline">Contact our support team</a> and we will get back to you within 24 hours.</p>
        </div>
      </div>
    </div>
  );
}
